import {
	colorDotButtonSX,
	colorDotInnerSX,
} from '@/components/blocks/ProductCardSelectColor/styles';
import { ProductType } from '@/data/types/Product';
import { Box, ButtonBase } from '@mui/material';
import {
	getProductColor,
	getProductColorName,
	hasTwoColors,
} from 'presentation/utils/custom/productColor';

interface Props {
	variant: ProductType | string;
	isSelected: boolean;
	onClick: (e: any) => void;
}

export const ProductColor = ({ variant, isSelected, onClick }: Props) => {
	const colors = getProductColor(variant);
	const activeDoubleColor = hasTwoColors(colors);
	const colorName = getProductColorName(variant);

	return (
		<ButtonBase
			title={colorName}
			aria-label={colorName}
			sx={colorDotButtonSX(isSelected)}
			onClick={onClick}
		>
			<Box sx={{ ...colorDotInnerSX, background: activeDoubleColor ? undefined : colors.color1 }}>
				{activeDoubleColor ? (
					<>
						<Box
							sx={{
								position: 'absolute',
								width: '100%',
								height: '100%',
								background: colors.color1,
								clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)',
							}}
						/>
						<Box
							sx={{
								position: 'absolute',
								width: '100%',
								height: '100%',
								background: colors.color2,
								clipPath: 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)',
							}}
						/>
					</>
				) : null}
			</Box>
		</ButtonBase>
	);
};
